export { default } from './TagDisplay';



// WEBPACK FOOTER //
// ./app/components/shared/UGC/TagDisplay/index.js